import { RocketOutlined } from '@ant-design/icons';
import * as React from 'react';
import { antGrey, runwayColors } from '../styles/globalStyles';

const SubscriptionPlanIcon: React.FC<{
    mini?: boolean;
}> = ({ mini = false }) => {
    const iconSize = mini ? 16 : 23;
    return (
        <div
            style={{
                width: iconSize,
                height: iconSize,
                backgroundColor: antGrey.grey8,
                borderRadius: 12,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexShrink: 0,
            }}
        >
            <RocketOutlined
                style={{
                    margin: 0,
                    color: runwayColors.white,
                    transform: 'rotate(30deg)',
                    fontSize: mini ? 10 : 'initial',
                }}
            />
        </div>
    );
};

export default SubscriptionPlanIcon;
